module.exports = __webpack_public_path__ + "static/media/ask-land.6cd66123.jpg";